import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/product-detail/page";
import SolutionsPage from "../pages/solutions/page";
import BespokePage from "../pages/bespoke/page";
import PricingPage from "../pages/pricing/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import AdvisorAnalyticsPage from "../pages/advisor-analytics/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:productId",
    element: <ProductDetailPage />,
  },
  {
    path: "/solutions",
    element: <SolutionsPage />,
  },
  {
    path: "/bespoke",
    element: <BespokePage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/advisor-analytics",
    element: <AdvisorAnalyticsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
